import { Box, Fade, Stack, TextField, Typography } from "@mui/material";
import React from "react";

import Divider from "@mui/material/Divider";

import { Delete, DeleteSweep, Lock, LockOpen } from "@mui/icons-material";
import IconButtonWithLabel from "../../IconButtonWithLabel";
import PolygonTypeMenu from "../TypeMenu";
import { useState } from "react";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";

const ToolbarDesignerEditingPolygon = ({
  name,
  type,
  locked,
  onDelete,
  onDeleteAll,
  onToggleLock,
  onTypeChange,
  onNameChange,
  onPlants,
}) => {
  const [editingIndex, setEditingIndex] = useState(-1);
  const handleNameChange = (event) => {
    onNameChange(event.target.value);
  };
  const handleNameClick = (index) => {
    setEditingIndex(index);
  };

  const handleNameBlur = () => {
    setEditingIndex(-1);
    // onChange(polygons);
  };
  return (
    <Fade in={type != null} timeout={500}>
      <Box
        style={{
          display: "flex",
          position: "fixed",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
          pointerEvents: "none",
          padding: "24px",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Box
          style={{
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            pointerEvents: "auto",
            WebkitUserSelect: "none",
            background: "rgb(255,255,255)",
            boxSizing: "border-box",
            boxShadow:
              "0 0 0 1px #0000001a, 0 3px 16px #00000014, 0 2px 6px 1px #00000017",
            borderRadius: "14px",
            position: "relative",
            alignSelf: "center",
          }}
        >
          <Box
            style={{
              position: "relative",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Stack direction={"row"}>
              <Box
                // onClick={onNameChange}
                style={{
                  padding: "0 1rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <Typography variant="body1">{name}</Typography> */}
                {editingIndex != -1 ? (
                  <TextField
                    label="Polygon Name"
                    value={name}
                    onChange={handleNameChange}
                    onBlur={handleNameBlur}
                    style={{
                      width: "8rem",
                    }}
                    variant="standard"
                    autoFocus
                  />
                ) : (
                  <Typography
                    variant="body1"
                    onClick={handleNameClick}
                    sx={{ cursor: "pointer" }}
                  >
                    {name || "Polygon"}
                  </Typography>
                )}
              </Box>

              <Divider orientation="vertical" flexItem />
              <Box>
                <PolygonTypeMenu onPolygonChange={onTypeChange} type={type} />
              </Box>

              <Divider orientation="vertical" flexItem />
              <Box onClick={onPlants}>
                <IconButtonWithLabel
                  label="Plants"
                  icon={<LocalFloristIcon />}
                />
              </Box>
              {/* Lock */}
              <Box onClick={onToggleLock}>
                <IconButtonWithLabel
                  label="Lock"
                  icon={locked ? <Lock /> : <LockOpen />}
                />
              </Box>
              {/* Delete */}
              <Box onClick={onDelete}>
                <IconButtonWithLabel label="Delete" icon={<Delete />} />
              </Box>
              {/* Delete All */}
              <Box onClick={onDeleteAll}>
                <IconButtonWithLabel
                  label="Delete All"
                  icon={<DeleteSweep />}
                />
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default ToolbarDesignerEditingPolygon;
